export default "__VITE_ASSET__CKp3Xdrv__"